import React from 'react';
import { FileText, Download, TrendingUp, Users, Globe } from 'lucide-react';
import Card3D from '../ui/Card3D';
import { colors } from '../../styles/theme';

const keyFigures = [
  {
    icon: <Users className="w-6 h-6" />,
    label: "A Dynamic Team",
    value: "Created by students, for students"
  },
  {
    icon: <Globe className="w-6 h-6" />,
    label: "A Promising Future",
    value: "European ambitions"
  },
  {
    icon: <TrendingUp className="w-6 h-6" />,
    label: "A Strong Community",
    value: "Boost your project with us"
  }
];

const PressKitSection = () => {
  const handleDownload = () => {
    // Create a download link
    const link = document.createElement('a');
    link.href = '/src/public/presskit_europeanstudent.pdf';
    link.download = 'presskit_europeanstudent.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-4">Press Kit</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover our resources for the press and media
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          <Card3D>
            <div className="bg-white p-8 rounded-2xl shadow-lg h-full">
              <div className="flex items-start space-x-6">
                <div 
                  className="w-16 h-16 rounded-2xl flex-shrink-0 flex items-center justify-center"
                  style={{
                    backgroundColor: `${colors.primary}15`,
                    color: colors.primary
                  }}
                >
                  <FileText className="w-8 h-8" />
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-4">Press Kit 2024</h3>
                  <p className="text-gray-600 mb-6">
                    Our complete press kit includes:
                  </p>
                  <ul className="space-y-3 text-gray-600 mb-8">
                    <li className="flex items-center space-x-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
                      <span>Detailed presentation of EUROPEAN STUDENT</span>
                    </li>
                    <li className="flex items-center space-x-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
                      <span>Key figures and statistics</span>
                    </li>
                    <li className="flex items-center space-x-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
                      <span>High-resolution visuals</span>
                    </li>
                    <li className="flex items-center space-x-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
                      <span>Logos and graphic resources</span>
                    </li>
                  </ul>
                  <button
                    onClick={handleDownload}
                    className="inline-flex items-center px-6 py-3 rounded-lg text-white transition-colors hover:opacity-90"
                    style={{ backgroundColor: colors.primary }}
                  >
                    <Download className="w-5 h-5 mr-2" />
                    Download Press Kit
                  </button>
                </div>
              </div>
            </div>
          </Card3D>

          <div className="space-y-6">
            <h3 className="text-xl font-bold mb-6">Let's Build a Better Future Together</h3>
            {keyFigures.map((figure, index) => (
              <Card3D key={index}>
                <div className="bg-white p-6 rounded-xl shadow-lg">
                  <div className="flex items-center space-x-4">
                    <div 
                      className="w-12 h-12 rounded-xl flex items-center justify-center"
                      style={{
                        backgroundColor: `${colors.primary}15`,
                        color: colors.primary
                      }}
                    >
                      {figure.icon}
                    </div>
                    <div>
                      <p className="text-gray-600 text-sm">{figure.label}</p>
                      <p 
                        className="text-2xl font-bold"
                        style={{ color: colors.primary }}
                      >
                        {figure.value}
                      </p>
                    </div>
                  </div>
                </div>
              </Card3D>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PressKitSection;